export const DisabledContentContainerDefProps = {
  disabled: true
};